import React, { Fragment } from "react";

import Header from "../Header/Header";
import Footer from "../Footer/Footer";
import BackTop from "../UI/BackTop";
import Routers from "../../routers/Routers";

const Layout = () => {
  return (
    <Fragment>
      <Header />
      <div>
        <Routers />
        <BackTop />
      </div>
      <Footer />
    </Fragment>
  );
};

export default Layout;
